<template>
	<div class="flex flex_column text_left">
		<p>
			{{ $t("investor.exchange.modal.alfa.receivableConstraints.description") }}
		</p>
		<div class="light_bg_color default_radius margin_top">
			<div class="flex flex_between">
				<!-- Constraint select -->
				<div class="flex_1">
						<span class="secondary_color">
							{{ $t("investor.exchange.modal.alfa.receivableConstraints.select.description") }}
						</span>
					<md-field>
						<label>{{ $t("investor.exchange.modal.alfa.receivableConstraints.select.placeholder") }}</label>
						<TbSelect v-model="selectedConditions" md-dense multiple
								  @md-selected="onConditionSelect"
								  :options="filterOnlyEnabledConditionOptions(alfaConfig.receivableConditions)"
								  options-value-field="key"
								  options-display-field="translation"
								  data-vv-name="receivable_condition_select"
								  v-validate="modelValidations.condition"
						/>
					</md-field>
				</div>
			</div>

			<AlfaSettingsBlock v-for="conditionSetting in receivableConditionSettings" :key="conditionSetting.key"
							   :condition-setting="conditionSetting"
							   :config="getConditionConfigByKey(conditionSetting.key)"
							   :allowed-values-getter="alfaValueOptions"
							   @remove="removeConditionSetting"
							   class="margin_top"
							   ref="condition"
			/>
		</div>
	</div>
</template>

<script>
import AlfaSettingsBlock from "@/components/templates/investor/exchange/alfa/AlfaSettingsBlock";
import {mapGetters} from "vuex";
import {validateForm} from "@/validation/validation";

export default {
	components: {
		AlfaSettingsBlock,
	},
	props: {
		data: { type: Object, default: {} },
	},
	data() {
		return {
			selectedConditions: [],
			emptyConditionSetting: {
				key: "",
				filterType: null,
				value: null
			},
			isInSyncProgress: false,
			modelValidations: {
				condition: {
					deprecated: {
						valueGetter: function(value) {
							return this.getConditionConfigByKey(value).isDeprecated;
						}.bind(this),
					}
				}
			}
		};
	},
	computed: {
		...mapGetters({
			alfaConfig: "alfa/config",
			alfaValueOptions: "alfa/valueOptions"
		}),
		receivableConditionSettings() {
			return this.data.receivableConditions;
		},
	},
	beforeMount() {
		this.syncSelectedConditionsWithSettings();
	},
	methods: {
		getConditionConfigByKey(conditionKey) {
			return this.alfaConfig.receivableConditions.find(config => config.key === conditionKey)
		},
		filterOnlyEnabledConditionOptions(options) {
			return options.filter(o => !o.isDeprecated);
		},
		removeConditionSetting(conditionSetting) {
			let index = this.receivableConditionSettings.indexOf(conditionSetting);
			this.receivableConditionSettings.splice(index, 1);
		},
		onConditionSelect() {
			if (!this.isInSyncProgress) {
				this.updateReceivableConditionSettings();
			}
		},
		updateReceivableConditionSettings() {
			let previousReceivableConditionSettings = [...this.receivableConditionSettings];

			// clear current receivable conditions, because we build the list again based on the current selection
			this.receivableConditionSettings.splice(0);

			this.selectedConditions.forEach(selectedConditionKey => {
				let previousSettingForSelected = previousReceivableConditionSettings.find(previousSetting => previousSetting.key === selectedConditionKey);
				if (previousSettingForSelected) {
					this.receivableConditionSettings.push(previousSettingForSelected);
				} else {
					this.receivableConditionSettings.push({
						...this.emptyConditionSetting,
						key: selectedConditionKey
					});
				}
			});
		},
		syncSelectedConditionsWithSettings() {
			this.isInSyncProgress = true;

			this.selectedConditions = this.receivableConditionSettings.map(conditionSetting => conditionSetting.key);

			this.$nextTick(() => this.isInSyncProgress = false);
		},
		validate() {
			return Promise.all((this.$refs.condition ?? []).map((ref) => validateForm(ref,  ref.$validator)));
		}
	},
	watch: {
		receivableConditionSettings() {
			this.syncSelectedConditionsWithSettings();
		}
	}
};
</script>